import { requestToken } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/settings`;

class SettingsServices {
  async userTracking(payload) {
    try {
      let action = API_ROUTE + "/add-tracking";
      const response = await requestToken.post(action, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getUserTracking() {
    try {
      let action = API_ROUTE + "/get-tracking";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
  async getUsersTrackingHisotry() {
    try {
      let action = API_ROUTE + "/get-tracking-history";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default SettingsServices;
